<template>
	<div class="scheduled-posts-container">
		<section class="scheduled-posts-header">
			<div class="scheduled-posts-intro">
				<h1>Scheduled</h1>
				<p class="scheduled-posts-description">
					View all prior and currently scheduled marketing calendar social
					posts.
				</p>
			</div>
		</section>
		<section class="scheduled-posts-calendar">
			<VendastaCalendar />
		</section>
	</div>
</template>

<script>
import VendastaCalendar from '@/components/vendasta/VendastaCalendar.vue';

export default {
	name: 'MarketingCalendarScheduled',
	components: {
		VendastaCalendar,
	},
};
</script>

<style lang="scss" scoped>
.scheduled-posts-container {
	@include rem(padding, 0 30px);

	h1 {
		margin: 0;
	}
}

.scheduled-posts-header {
	width: 100%;
	@include rem(padding-top, 30px);
	@include rem(margin-right, 30px);

	@include phablet {
		display: block;
	}
}

.scheduled-posts-description {
	@include rem(margin, 8px 0 20px);
	@include rem(padding-bottom, 20px);
	font-size: $b360-font-size--small;
	@include rem(line-height, 25px);
}

.scheduled-posts-calendar {
	@include rem(padding-bottom, 20px);
}

@media (max-width: $mobile-max) {
	.scheduled-posts-container {
		@include rem(padding, 0 15px);
	}
}

@media (max-width: $breakpoint) {
	.scheduled-posts-header {
		width: 100%;
		margin-right: 0;
		@include rem(padding-top, 20px);
		position: relative;

		.suggested-posts-intro {
			display: none;
		}
	}
}
</style>
